import { DrgResponseDto } from 'src/contracts/drgResponseDto';
import { Code } from 'src/contracts/code';
import { isEmpty } from 'src/common/arrayUtil';

export function getDrgSaveMessage(drgs: DrgResponseDto[], types: string[]): string {
  const drgText = (drgs || []).filter(drg => drg.drg).map(drg => drg.grouper_type == 'APR' ? 'APR DRG' : 'MS DRG').join(' and ');

  let typeText = '';
  for (let i=0; i<types.length; i++) {

    if (i == types.length -1 && types.length > 1) {
      typeText += ' and '
    }

    typeText += types[i];

    if (i < types.length-2) {
      typeText += ', ';
    }
  }
  return `${drgText} Saved As ${typeText}`;
}

export function drgChanged(oldDrg: DrgResponseDto, newDrg: DrgResponseDto): boolean {

  return oldDrg?.drg != newDrg?.drg;
}

export type IsEqualComparer = (a: Code, b: Code) => boolean;

export function codeSetChanged(current: Code[], original: Code[], customComparer?: IsEqualComparer): boolean {

  if (current?.length != original?.length) {
    return true;
  }

  if (isEmpty(current)) {
    return false;
  }

  return current.some((code, index) => {
    return code?.code != original[index]?.code || (customComparer && !customComparer(code, original[index]));
  });
}